import styled, { css } from "styled-components"
import { NeutralTextLink } from "../../../ui/components/link/link.component"

const mobileOnly = css`
  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    display: none;
  }
`

export const MobileMenuElement = styled.div<{ opened: boolean }>`
  top: calc(var(--height) + 1px);
  max-height: calc(100vh - var(--height) - 1px);
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: ${({ opened }) => (opened ? 0 : "calc(-100vw - 22px);")};
  transition: left 0.3s linear;
  padding: 21px 0px 25px 0px;
  background: ${({ theme }) => theme.color.backgroundInverted};
  box-sizing: border-box;
  overflow: auto;
  box-shadow: 0 2px 20px 0 ${({ theme }) => theme.color.lightShadow};
  z-index: 9;
  ${mobileOnly};

  ul {
    padding: 0;
    margin: 0;
  }

  ${NeutralTextLink} {
    &.active {
      color: ${({ theme }) => theme.color.link};
    }
  }
`

export const Submenu = styled.ul`
  list-style: none;
  display: flex;
  margin-bottom: 50px;
  padding-left: 0;
  flex-wrap: wrap;

  ${NeutralTextLink} {
    text-transform: none;
    margin-right: 30px;
  }

  li {
    &:last-of-type {
      ${NeutralTextLink} {
        margin-right: 0;
      }
    }
  }
`
